import { Link } from 'react-router-dom';

const openRoles = [
  { title: 'Senior ML Engineer', type: 'Full-time · Remote' },
  { title: 'Growth Marketing Manager', type: 'Full-time · Remote / Hybrid' },
  { title: 'Product Designer', type: 'Full-time · Remote' },
];

export default function AboutCTA() {
  return (
    <>
      {/* Bottom CTA */}
      <section className="py-20 bg-stone-950">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5">
            Ready to see what AdForge<br />
            <span className="bg-gradient-to-r from-orange-400 to-amber-300 bg-clip-text text-transparent">
              can forge for you?
            </span>
          </h2>
          <p className="text-lg text-white/60 mb-10 max-w-xl mx-auto">
            Join 3,200+ businesses writing better ads in minutes — no agency, no guesswork, no wasted budget.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/signup"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-amber-400 text-white font-bold text-base px-8 py-4 rounded-xl hover:from-orange-600 hover:to-amber-500 transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-flashlight-fill" />
              Start Free — No Credit Card
            </Link>
            <Link
              to="/pricing"
              className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white font-semibold text-base px-8 py-4 rounded-xl hover:bg-white/20 transition-all duration-200 whitespace-nowrap"
            >
              View Pricing
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
